import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { Title } from '@angular/platform-browser';

import { Solution } from '../../models';

import { SolutionDescriptionComponent } from './solution-description/solution-description.component';

import { SolutionService } from '../../services';
import { LanguageService } from '../../services';

@Component({
  selector: 'solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.scss'],
  animations: [
    trigger('solutionState', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate(250)
      ]),
      transition(':leave', [
        animate(250, keyframes([
          style({ opacity: '1', offset: 0 }),
          style({ opacity: '0', offset: 1 }),
        ]))
      ]),
      transition('* <=> *', [
        animate(500, keyframes([ // Le double du setTimeout
          style({ opacity: '1', offset: 0 }),
          style({ opacity: '0', offset: 0.5 }),
          style({ opacity: '1', offset: 1 }),
        ]))
      ])
    ])
  ]
})
export class SolutionsComponent implements OnInit {

  imgurl: string = '../../assets/backgrounds/pingouins.jpeg';

  english: boolean;

  // *** Content *** //

  title: string;
  slogan: string;

  solutions: Solution[];
  selectedSolution: Solution;
  solutionState: string;

  @ViewChild(SolutionDescriptionComponent)
  el: SolutionDescriptionComponent;

  @ViewChild('icons')
  icons: ElementRef;

  text1: string;
  text2: string;

  // ***************************** //

  constructor(
    private solutionService: SolutionService,
    private titleService: Title,
    private languageService: LanguageService) { }

  ngOnInit() {
    this.titleService.setTitle('eyeSnap - Solutions');
    this.initContent();
    this.getSolutions();
  }

  onLanguage() {
    this.initContent();
    this.getSolutions();
    if (window.scrollY > window.innerHeight) {
      this.scrollToSolutions();
    }
  }

  // *** Content *** //

  initContent() {
    this.languageService.getLanguage()
      .subscribe(english => this.english = english);
    if (this.english) {
      this.title = 'Solutions';
      this.slogan = 'eyeSnap Technology for your images';
      this.text1 ='Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat';
      this.text2 = 'We deliver solutions adapted to your usecase';
    } else {
      this.title = 'Solutions';
      this.slogan = 'La technologie eyeSnap fait parler vos images !';
      this.text1 = 'eyeSnap développe des services sur-mesure de reconnaissance visuelle pour ses clients. \n eyeSnap s\'intégre facilement à des applications existantes via son API en mode cloud ou en mode embarqué.';
      this.text2 = 'eyeSnap réalise des études de faisabilité et du prototypage, du conseil et de la formation, de l\'intégration et du développement applicatif sur-mesure.';
    }
  }

  // *************** Solution display **************** //

  deselectSolutions() {
    for (let sol of this.solutions) {
      sol.selected = true;
    }
    this.selectedSolution = null;
  }

  scrollToSolutions() {
    this.icons.nativeElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  getSolutions() {
    if (this.english) {
      this.solutionService.getEnglishSolutions()
        .subscribe(solutions => this.solutions = solutions);
    } else {
      this.solutionService.getFrenchSolutions()
        .subscribe(solutions => this.solutions = solutions);
    }
    this.deselectSolutions();
  }

  onSelected(solution: Solution) {
    if (solution == this.selectedSolution) {
      this.scrollToSolutions();
      this.deselectSolutions();
    } else {
      for (let sol of this.solutions) {
        sol.selected = false;
      }
      solution.selected = true;
      this.solutionState = solution.name;
      setTimeout(() => this.selectedSolution = solution, 250)
      setTimeout(() => this.el.scrollToDescription(), 250);
    }
  }

}
